import { Disclosure } from '@reach/disclosure';
import { ReactComponent as EditIcon } from 'assets/icons/icon-edit.svg';
import React, {
  forwardRef,
  MutableRefObject,
  ReactElement,
  ReactNode,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import {
  InitialValues,
  InitialValuesWrapper,
  StyledDisclosureButton,
  StyledDisclosurePanel,
  Wrapper,
} from './edit-toggle.styles';

interface Props {
  name: string;
  value: string;
  isOpen?: boolean;
  openTitle?: ReactElement | string;
  ref?: MutableRefObject<unknown>;
  children?: ReactNode;
}

export interface EditToggleHandles {
  toggle(): void;
}

const EditToggle = forwardRef<EditToggleHandles, Props>(
  ({ name, value, children, openTitle, isOpen: isOpenProp }, ref) => {
    const [isOpen, setOpen] = useState(isOpenProp || false);

    useEffect(() => {
      if (isOpenProp !== undefined) {
        setOpen(isOpenProp);
      }
    }, [isOpenProp]);

    useImperativeHandle(ref, () => ({
      toggle() {
        setOpen((open) => !open);
      },
    }));

    return (
      <Wrapper>
        <Disclosure open={isOpen} onChange={setOpen.bind(this, !isOpen)}>
          <InitialValuesWrapper isOpen={isOpen}>
            {isOpen && openTitle}
            {!isOpen && (
              <InitialValues>
                <strong>{name}: </strong>
                <span>{value}</span>
              </InitialValues>
            )}
            <StyledDisclosureButton aria-label={`Edit ${name}`}>
              <EditIcon aria-hidden />
            </StyledDisclosureButton>
          </InitialValuesWrapper>
          <StyledDisclosurePanel>{children}</StyledDisclosurePanel>
        </Disclosure>
      </Wrapper>
    );
  }
);

export default EditToggle;
